import requests from '../../../../redux/reducer/requests'
import content from '../../../../redux/reducer/content'
import { useDispatch } from 'react-redux'

export default function useGameCallbacks() {
  const dispatch = useDispatch()

  return {
    gameStart: (type) => dispatch(requests.thunks.gameStart(type)),
    gameEnd: (gameData) => dispatch(requests.thunks.gameEnd(gameData)),
    spfGameStart: (gameData) => dispatch(requests.thunks.spfGameStart(gameData)),
    spfGameEnd: (gameData) => dispatch(requests.thunks.spfGameEnd(gameData)),
    spfGameExit: () => dispatch(requests.thunks.spfGameExit()),
    gamePause: () => dispatch(requests.thunks.gamePause()),
    getGameSettings: () => dispatch(requests.thunks.getGameSettings()),
    returnAttempts: (attempts) => dispatch(requests.thunks.returnAttempts(attempts)),
    sendGameProgress: (data) => dispatch(requests.thunks.sendGameProgress(data)),
    setGameDataProgress: (data) => dispatch(content.actions.setGameDataProgress(data)),
    setActiveGameRatingName: (type) => dispatch(content.actions.setActiveGameRatingName(type)),
    setActiveGameSection: (section) => dispatch(content.actions.setActiveGameSection(section)),
    setActiveTasksSection: (section) => dispatch(content.actions.setActiveTasksSection(section)),
  }
}
